import React, { useState, useEffect, lazy, Suspense } from "react";
import Loader from "../component/Loader/Loader";
import LoaderMain from "../component/Loader/RadiusLoader/LoaderMain";

const HeroSection = lazy(() =>
  import("../component/core/HomePage/HeroSection")
);

export default function HomePage() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      const checkSiteLoaded = () => {
        if (document.readyState === "complete") {
          setIsLoading(false);
        } else {
          window.addEventListener("load", () => setIsLoading(false));
        }
      };

      checkSiteLoaded();

      return () => {
        window.removeEventListener("load", () => setIsLoading(false));
      };
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {isLoading ? (
        <LoaderMain />
      ) : (
        <Suspense fallback={<LoaderMain />}>
          <HeroSection />
        </Suspense>
      )}
      
    </div>
  );
}
